import useBaseApiHook from "services/useBaseApiHook";
import unauthenticatedApi from "services/unauthenticatedApi"; // atau sesuaikan path
import LocalStorageUtils from 'utils/LocalStorage';
const REPO_URL = {
    getDownloadExcelWbsReport: '/download/report/wbs-form-detail',
    getDownloadExcelOrganizationReport: '/download/report/org',
    getDownloadExcelDivisionReport: '/download/report/div',
    getDownloadExcelDepartmentReport: '/download/report/dept',
    getDownloadExcelPositionReport: '/download/report/pos',
    
    
};

const useDownloadReportRepo = (initialLoading = false) => {
    const { isLoading, data, error } = useBaseApiHook(initialLoading);

    const getDownloadExcelWbsReport = async (payload) => {
        const token = LocalStorageUtils.jwtToken.get(); // ambil token dari local storage
        const response = await unauthenticatedApi.post(
            REPO_URL.getDownloadExcelWbsReport,
            payload,
            {
                responseType: 'blob',
                headers: {
                     Authorization: `Bearer ${token}`, // ⬅️ tambahkan ini!
                    Accept: 'application/octet-stream',
                },
            }
        );

        return response;
    };

    const getDownloadExcelOrganizationReport = async (payload) => {
        const token = LocalStorageUtils.jwtToken.get(); // ambil token dari local storage
        const response = await unauthenticatedApi.post(
            REPO_URL.getDownloadExcelOrganizationReport,
            payload,
            {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${token}`, // ⬅️ tambahkan ini!
                    Accept: 'application/octet-stream',
                },
            }
        );

        return response;
    };

    const getDownloadExcelDivisionReport = async (payload) => {
        const token = LocalStorageUtils.jwtToken.get(); // ambil token dari local storage
        const response = await unauthenticatedApi.post(
            REPO_URL.getDownloadExcelDivisionReport,
            payload,
            {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${token}`, // ⬅️ tambahkan ini!
                    Accept: 'application/octet-stream',
                },
            }
        );

        return response;
    };

    const getDownloadExcelDepartmentReport = async (payload) => {
        const token = LocalStorageUtils.jwtToken.get(); // ambil token dari local storage
        const response = await unauthenticatedApi.post(
            REPO_URL.getDownloadExcelDepartmentReport,
            payload,
            {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${token}`, // ⬅️ tambahkan ini!
                    Accept: 'application/octet-stream',
                },
            }
        );

        return response;
    };

    const getDownloadExcelPositionReport = async (payload) => {
        const token = LocalStorageUtils.jwtToken.get(); // ambil token dari local storage
        const response = await unauthenticatedApi.post(
            REPO_URL.getDownloadExcelPositionReport,
            payload,
            {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${token}`, // ⬅️ tambahkan ini!
                    Accept: 'application/octet-stream',
                },
            }
        );

        return response;
    };

    return {
        isLoading,
        data,
        error,
        getDownloadExcelWbsReport,
        getDownloadExcelOrganizationReport,
        getDownloadExcelDivisionReport,
        getDownloadExcelDepartmentReport,
        getDownloadExcelPositionReport
    };
};

export default useDownloadReportRepo;
